export default "__VITE_ASSET__DK83llq$__"